import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonGrid,
  IonLabel,
  IonList,
  IonRow,
  IonToolbar,
} from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { getRtsOptionsSelector } from '../../../../options/selectors/rtsOptions.selector'
import { getRevisedTraumaScoreSelector } from '../selectors'
import { IOption } from '../../../../../common/common.types'
import { setRTSRespRate, setRTSSysBp, saveRTSData, resetRTSData } from '../store/revisedTraumaScore.actions'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'
import './RevisedTraumaScore.content.css'
import { showAlert } from '../../../../vitals/store/vitals.actions'
import { IDataPointsConfig } from '../../../../configurations/store/configurations.types'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'

const RevisedCommaScoreContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const rtsOptions = useSelector(getRtsOptionsSelector)
  const { rtsRespRateOptions, rtsSysBpOptions } = rtsOptions
  const datapointsConfig: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_INITGCS } = datapointsConfig

  const pediatricTraumaScoreState = useSelector(getRevisedTraumaScoreSelector)
  const { rtsResp, rtsBp, rts } = pediatricTraumaScoreState

  const showGCSDisabledAlert = () => {
    dispatch(showAlert({ message: 'Cannot calculate RTS with Initial GCS disabled.' }))
  }

  const saveRTSDataOnChange = () => {
    dispatch(saveRTSData())
  }

  const setRtsRespRateOnChange = (option: IOption) => {
    if (rtsBp && option && DP_INITGCS === 0) {
      showGCSDisabledAlert()
    }
    dispatch(setRTSRespRate(option))
    saveRTSDataOnChange()
  }

  const setRtsSysBpOnChange = (option: IOption) => {
    if (option && rtsResp && DP_INITGCS === 0) {
      showGCSDisabledAlert()
    }
    dispatch(setRTSSysBp(option))
    saveRTSDataOnChange()
  }

  const resetRevisedTraumaScoreData = () => {
    dispatch(resetRTSData())
    saveRTSDataOnChange()
  }

  return (
    <>
      <IonContent fullscreen className='ion-margin-bottom'>
        <IonList>
          <IonGrid>
            <IonRow className='ion-margin-bottom'>
              <IonLabel>Total Score </IonLabel>
              {rts != null && <IonLabel className='custom-number-label'> {rts}</IonLabel>}
            </IonRow>
            <SingleSelect
              dataTestID='rtsBp'
              options={rtsSysBpOptions}
              selectedOption={rtsBp}
              listHeader={t('neuro.revisedTraumaScore.rtsBp')}
              label={t('neuro.revisedTraumaScore.rtsBp')}
              action={setRtsSysBpOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
            <SingleSelect
              dataTestID='rtsResp'
              options={rtsRespRateOptions}
              selectedOption={rtsResp}
              listHeader={t('neuro.revisedTraumaScore.rtsResp')}
              label={t('neuro.revisedTraumaScore.rtsResp')}
              action={setRtsRespRateOnChange}
              showSelectedOptionId={'id'}
            />
            <hr className='field-divider' />
          </IonGrid>
        </IonList>
      </IonContent>
      <IonFooter>
        <IonToolbar color='light' className='p-10'>
          <IonButtons className='btn-grps'>
            <IonButton
              className='btn btn-tablet'
              color='danger'
              fill='outline'
              expand='block'
              onClick={resetRevisedTraumaScoreData}>
              {t('common.buttons.Clear')}
            </IonButton>
            <IonButton
              className='btn btn-tablet btn-primary'
              expand='block'
              onClick={() => {
                history.push(TabConstants.INITIAL_ASSESSMENT)
              }}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </>
  )
}

export default RevisedCommaScoreContent
